import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import img1 from "../../assets/img1.png";
import { useEffect, useRef, useState } from "react";
import "../../styles/scss/hero.scss";
import { useTranslation } from "react-i18next";
import { useTranslationProvider } from "../../providers/TranslationProvider";
import { Link } from "react-scroll";

export const Hero = () => {
	const { t } = useTranslation();
	const { language } = useTranslationProvider();
	const elementRef = useRef(null);
	function redirect(url: string) {
		window.location.href = url;
	}

	const [animationPlayed, setAnimationPlayed] = useState<boolean>(false);
	useEffect(() => {
		const handleMouseMovement = (e: any) => {
			const rect = e.target.getBoundingClientRect();
			const mouseX = e.clientX - rect.left;
			const mouseY = e.clientY - rect.top;

			e.target.style.setProperty("--mouse-x", `${mouseX}deg`);
			e.target.style.setProperty("--mouse-y", `${mouseY}deg`);
		};
		const panel = document.querySelector("#hero-image");
		console.log("panel:", panel);
		if (panel == null) return;

		panel.addEventListener("mousemove", handleMouseMovement);

		return () => {
			panel.removeEventListener("mousemove", handleMouseMovement);
		};
	}, []);
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					/**Make sure that the timeout time is equal to the animation time */
					if (entry.isIntersecting) {
						if (
							!entry.target.classList.contains(
								"appear-from-right"
							)
						) {
							entry.target.classList.add("appear-from-right");
							setTimeout(() => {
								setAnimationPlayed(true);
							}, 2000);
							observer.unobserve(entry.target);
						}
					}
				});
			},
			{ threshold: 0.5 }
		);

		if (elementRef.current) {
			observer.observe(elementRef.current);
		}

		return () => {
			if (elementRef.current) {
				observer.unobserve(elementRef.current);
			}
		};
	}, [animationPlayed]);

	const [textAnimation, setTextAnimation] = useState<boolean>(false);
	const textContainerRef = useRef(null);
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					/**Make sure that the timeout time is equal to the animation time */
					if (entry.isIntersecting) {
						if (
							!entry.target.classList.contains(
								"appear-from-bottom"
							)
						) {
							entry.target.classList.add("appear-from-bottom");
							setTimeout(() => {
								setTextAnimation(true);
							}, 2000);
							observer.unobserve(entry.target);
						}
					}
				});
			},
			{ threshold: 0.5 }
		);

		if (textContainerRef.current) {
			observer.observe(textContainerRef.current);
		}

		return () => {
			if (textContainerRef.current) {
				observer.unobserve(textContainerRef.current);
			}
		};
	}, [textAnimation]);

	return (
		<>
			<Box
				sx={{
					background: "#232839",
					marginTop: "0",
					padding:
						window.innerWidth > 600 ? "18vh 0px 12vh" : "6vh 16px",
				}}
			>
				<Grid container spacing={0}>
					<Grid md={1} xs={12}></Grid>

					<Grid
						md={5}
						xs={12}
						id="hero-text-container"
						ref={textContainerRef}
					>
						<Typography
							variant="h2"
							align="left"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "600",
								fontSize:
									window.innerWidth < 600 ? "32px" : "52px",
								marginTop:
									window.innerWidth > 600 ? "8vh" : "0vh",
							}}
						>
							{language == "it" && (
								<>
									Unisciti al mondo di Xsee, la prima{" "}
									<span style={{ color: "#2AD4D4" }}>
										{" "}
										social trading{" "}
									</span>{" "}
									app sui CFD
								</>
							)}
							{language == null ||
								(language == "en" && (
									<>
										Join the world of Xsee, the first{" "}
										<span style={{ color: "#2AD4D4" }}>
											social trading
										</span>{" "}
										app on CFDs
									</>
								))}
						</Typography>
						<Typography
							mt={2}
							variant="h6"
							align="left"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "300",
								fontSize:
									window.innerWidth < 600 ? "16px" : "18px",
							}}
						>
							{t("landing.hero.body")}
						</Typography>
						<Link to="trader"
							spy={true}
							smooth={true}
							offset={-150}
							duration={500}>
							<Button
								variant="contained"
								color="secondary"
								sx={{
									textTransform: "none",
									margin: "24px 0 8px 0",
									fontWeight: "600",
									padding: "10px 60px",
									borderRadius: "100px",
									fontSize: "16px",
								}}

							>
								{t("general.discoverTrader")}
							</Button>
						</Link>
					</Grid>

					<Grid
						md={5}
						xs={12}
						className="container-hero-image"
						ref={elementRef}
						id="hero-image-container"
					>
						<img
							id="hero-image"
							className="hero-image"
							src={img1}
						// style={{
						// 	width: window.innerWidth > 600 ? "90%" : "90%",
						// }}
						></img>
						<div id="hero-first-bubble-background"></div>
						<div id="hero-second-bubble-background"></div>
						<div id="hero-third-bubble-background"></div>
						<div id="hero-fourth-bubble-background"></div>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};
